<samweb-skill-short-info-icon *ngIf="!isOverallSkill" [skills]="skills" [skillConfiguration]="skillConfiguration">
</samweb-skill-short-info-icon>

<span
   [ngClass]="{ loggedOff: visualizeLoggedOnState && !(loggedOnUsers$ | async) }"
   [innerHTML]="skillConfiguration?.skillName | translate | highlightText$: searchValue | async"
>
</span>
